import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Loading from 'components/Loading';
import Util from 'utility';
import RecipeSearch from 'components/RecipeSearch';
import RecipeDetail from './RecipeDetail';
import { openModal, closeModal } from 'actions/index';

function RecipeList() {
    const data = useSelector(state => state);
    const dispatch = useDispatch();
    const history = useHistory();
    const { hash } = useParams();
    const [loading, setLoading] = useState(false);

    const showMyRecipes = () => {
        history.push('/recipe');
        history.push('/recipe/me');
    };

    const openRecipeDetail = (id, e) => {
        if (e) e.preventDefault();
        dispatch(closeModal());
        dispatch(openModal({
            title: 'Detail receptu',
            class: 'dialog-big',
            content: (
                <RecipeDetail id={id} showMyRecipes={showMyRecipes} beginReload={() => setLoading(true)} endReload={() => setLoading(false)} />
            )
        }));
    };

    useEffect(() => {
        if (Util.isLectureLikeMode(data.appMode) && typeof data.appModeData.lectureInfoData !== 'object') {
            history.push('/');
        }
        if (typeof hash === 'string') {
            openRecipeDetail(hash, false);
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (loading) return <Loading />;

    return (
        <div className="w-full flex flex-col">
            <RecipeSearch onClick={openRecipeDetail} newRecipeLink={true} />
        </div>
    );
}

export default RecipeList;
